<template>
  <div>
    <v-card>
      <v-data-table
        v-model="tableValue"
        :headers="workflowUi(headers)"
        :items="workflowUi(items)"
        :rows-per-page-items="rowsPerPageItems"
        item-key="id"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ workflowLabel(props.item.name) }}</td>
            <td>{{ workflowLabel(props.item.visits) }}</td>
            <td>
              <v-icon
                small
                @click="$emit('delete', props.item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ adminText('workflowsAll.create_your_first_referral_3d73968', 'Create your first referral') }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'referrals-table',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableValue: [],
      rowsPerPageItems: [5, 10, 20],
      headers: [
        {
          text: 'workflowsAll.referral_1c6984f',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'workflowsAll.visits_6a4be2f',
          align: 'left',
          sortable: true,
          value: 'visits',
        },
        {
          text: 'workflowsAll.actions_c3cd636',
          align: 'left',
          sortable: false,
          value: null,
        },
      ],
    }
  },
}
</script>

<style>
</style>
